// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { DareKitData, Types } from './types';

interface IRequestTaxasDare {
	taxasCorreio: boolean;
	numeroRg: string;
	nome: string;
}

export interface IRequestGerarDare {
	cpf: string;
	enderecoContribuinte: string;
	postoCodigo: number;
	postoDescricao: string;
	ipUsuario: string;
	emailTo?: string;
	taxasReq: IRequestTaxasDare[];
	idCidadao: string;
	usuario: string;
	senha: string;
}

export function gerarDareRequest(
	token: string,
	payload: IRequestGerarDare,
): ReducerActionRotaSP {
	return {
		type: Types.GERAR_DARE_REQUEST,
		token,
		payload,
	};
}
export function gerarDareSuccess(payload: object): ReducerActionRotaSP {
	return {
		type: Types.GERAR_DARE_SUCCESS,
		payload,
	};
}
export function gerarDareFailure(): ReducerActionRotaSP {
	return {
		type: Types.GERAR_DARE_FAILURE,
		payload: null,
	};
}
export function gerarDareClear(): ReducerActionRotaSP {
	return {
		type: Types.GERAR_DARE_CLEAR,
		payload: null,
	};
}

export function dareKitRequest(payload: DareKitData): ReducerActionRotaSP {
	return {
		type: Types.DARE_KIT_REQUEST,
		payload,
	};
}
export function dareKitClear(): ReducerActionRotaSP {
	return {
		type: Types.DARE_KIT_CLEAR,
		payload: null,
	};
}
